<div
  class="subtitle-block"
  [class.subtitle-block--selected]="selected"
  (click)="onBlockClick($event)"
>
  <div class="subtitle-block__header">
    <span class="subtitle-block__timing">{{ startTimeStr }} → {{ endTimeStr }}</span>
    <div class="subtitle-block__actions">
      <button type="button" class="subtitle-block__action-btn" (click)="onSplitClick($event)">
        Split
      </button>
      <button type="button" class="subtitle-block__action-btn subtitle-block__action-btn--danger" (click)="onDeleteClick($event)">
        Delete
      </button>
    </div>
  </div>
  <textarea
    class="subtitle-block__text"
    [value]="subtitle.Text"
    (click)="$event.stopPropagation()"
    (input)="textChange.emit({ id: subtitle.id, text: $any($event.target).value })"
    rows="2"
  ></textarea>
</div>
